export const FL_ADD = 'flowline/added';
export const FL_DEL = 'flowline/deleted';
export const FL_EDIT = 'flowline/edited';